import { render, staticRenderFns } from "./DataOutput.vue?vue&type=template&id=b1bb31fc&scoped=true&"
import script from "./DataOutput.vue?vue&type=script&lang=ts&"
export * from "./DataOutput.vue?vue&type=script&lang=ts&"
import style0 from "./DataOutput.vue?vue&type=style&index=0&id=b1bb31fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bb31fc",
  null
  
)

export default component.exports